/**
 * Auth store Zustand — NE STOCKE JAMAIS DE TOKEN.
 *
 * Les tokens JWT sont en cookies httpOnly côté serveur. Le store ne
 * conserve que le user + memberships + permissions effectives.
 */
import { create } from "zustand";

import type { MeResponse } from "./types";

interface AuthState {
  me: MeResponse | null;
  isLoading: boolean;
  setMe: (me: MeResponse | null) => void;
  setLoading: (loading: boolean) => void;
  reset: () => void;
}

export const useAuthStore = create<AuthState>((set) => ({
  me: null,
  isLoading: true,
  setMe: (me) => set({ me, isLoading: false }),
  setLoading: (loading) => set({ isLoading: loading }),
  reset: () => set({ me: null, isLoading: false }),
}));
